import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import Crosshairs from './Crosshairs';
import { PlaneView } from '~/engine/view/views/PlaneView';
import { viewManagerState } from '~/state/atoms/engineAtoms';

export interface CrosshairsComponentProps {
    view: PlaneView | null;
}

const CrosshairsComponent = ({ view }: CrosshairsComponentProps) => {
    const viewManager = useRecoilValue(viewManagerState);

    // Re-render when the plane intersection point changes (e.g. mouse wheel
    // scroll). Without this, crosshairs in coronal/sagittal views only update
    // on mouse movement (debounced lastMousePositionState), so they lag behind
    // after a wheel scroll in the transversal view.
    const [, setRenderTick] = useState(0);
    useEffect(() => {
        if (!viewManager) {
            return;
        }
        const onChange = () => setRenderTick((t) => t + 1);
        viewManager.addEventListener('planeIntersectionPointChanged', onChange);
        return () => {
            viewManager.removeEventListener(
                'planeIntersectionPointChanged',
                onChange
            );
        };
    }, [viewManager]);

    const vertical = view?.planeIntersectionPointToScrollLevel().vertical;
    const horizontal = view?.planeIntersectionPointToScrollLevel().horizontal;

    const handleCrosshairChange = (
        type: 'horizontal' | 'vertical',
        delta: number
    ) => {
        if (!view) {
            return;
        }
        view.scrollLevelToPlaneIntersectionPoint(type, delta);
    };

    return (
        vertical &&
        horizontal && (
            <Crosshairs
                view={view ?? null}
                vertical={vertical}
                horizontal={horizontal}
                handleCrosshairChange={handleCrosshairChange}
            />
        )
    );
};

export default CrosshairsComponent;
